import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[CurrencySvg]',
  standalone: true
})
export class CurrencySvgDirective {
  /** Holds the currency identifier or code input value. */
  @Input() currencyId: string | number;

  /** Stores available SVG icons keyed by currency id. */
  private icons = {
    '1028': `<svg width="10px" height="12px" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1124.14 1256.39"><defs><style>.cls-1 {fill: #231f20;}</style></defs><path class="cls-1" d="M699.62,1113.02h0c-20.06,44.48-33.32,92.75-38.4,143.37l424.51-90.24c20.06-44.47,33.31-92.75,38.4-143.37l-424.51,90.24Z"/><path class="cls-1" d="M1085.73,895.8c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.33v-135.2l292.27-62.11c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.27V66.13c-50.67,28.45-95.67,66.32-132.25,110.99v403.35l-132.25,28.11V0c-50.67,28.44-95.67,66.32-132.25,110.99v525.69l-295.91,62.88c-20.06,44.47-33.33,92.75-38.42,143.37l334.33-71.05v170.26l-358.3,76.14c-20.06,44.47-33.32,92.75-38.4,143.37l375.04-79.7c30.53-6.35,56.77-24.4,73.83-49.24l68.78-101.97v-.02c7.14-10.55,11.3-23.27,11.3-36.97v-149.98l132.25-28.11v270.4l424.53-90.28Z"/></svg>`,
  }

  constructor(private el: ElementRef) { }

  ngOnInit(): void {
    this.updateIcon();
  }

  /** Resolves and renders the correct currency icon or text. */
  private updateIcon(): void {
    const currencyCode = this.currencyId != null ? String(this.currencyId).trim() : '';
    if (!currencyCode) {
      this.el.nativeElement.textContent = '';
      return;
    }

    const normalized = currencyCode.toUpperCase();
    const sarIcon = this.icons['1028'];
    if (normalized === 'SAR' || normalized === '1028') {
      this.el.nativeElement.innerHTML = sarIcon;
      return;
    }

    this.el.nativeElement.textContent = currencyCode;
  }
}
